import React from "react";

const MiroIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2773_1188)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M31.3333 0H8.66667C3.8802 0 0 3.8802 0 8.66667V31.3333C0 36.1198 3.8802 40 8.66667 40H31.3333C36.1198 40 40 36.1198 40 31.3333V8.66667C40 3.8802 36.1198 0 31.3333 0Z",
  fill: "#FFD02F"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.7846 5H23.3944L27.0529 11.4286L19.0041 5H14.6139L18.6383 12.8572L10.2236 5H5.83337L10.2236 15L5.83337 35H10.2236L18.6383 13.5714L14.6139 35H19.0041L27.0529 12.1428L23.3944 35H27.7846L35.8334 10L27.7846 5Z",
  fill: "#050038"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2773_1188"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "white"
}))));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(MiroIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;